export type TimelineAnimationWindow={startInSeconds:number;endInSeconds:number};
const record=(value:unknown):value is Record<string,unknown>=>!!value&&typeof value==='object'&&!Array.isArray(value);
export function readTimelineAnimationWindow(value:unknown):TimelineAnimationWindow|null{
  if(!record(value)||Object.keys(value).some(key=>key!=='startInSeconds'&&key!=='endInSeconds')
    ||typeof value.startInSeconds!=='number'||typeof value.endInSeconds!=='number'
    ||!Number.isFinite(value.startInSeconds)||!Number.isFinite(value.endInSeconds)||!Number.isFinite(value.endInSeconds-value.startInSeconds)||value.endInSeconds<=value.startInSeconds)return null;
  return {startInSeconds:value.startInSeconds,endInSeconds:value.endInSeconds};
}
export function hasValidTimelineAnimationWindows(item:unknown,fps=1):boolean{
  if(!record(item)||!Array.isArray(item.animations))return true;
  return item.animations.every(animation=>{
    if(!record(animation)||animation.timelineWindow===undefined)return true;
    const window=readTimelineAnimationWindow(animation.timelineWindow);if(!window)return false;
    const start=window.startInSeconds*fps,end=window.endInSeconds*fps;
    return Number.isFinite(start)&&Number.isFinite(end)&&Number.isFinite(end-start)&&end>start;
  });
}
export function hasTimelineAnimationWindows(document:unknown):boolean{
  if(!record(document)||!record(document.items))return false;
  return Object.values(document.items).some(item=>record(item)&&Array.isArray(item.animations)&&item.animations.some(animation=>record(animation)&&animation.timelineWindow!==undefined));
}
